<div class="editor">

  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
       <!-- Chọn khối hiển thị -->
      <mat-form-field style="width: 100%">
        <mat-label>{{'chon_khoi_hien_thi' | translate}}</mat-label>
        <mat-select [(ngModel)]="staticdata['id_freeblock']" (ngModelChange)="updateObject()">
          <mat-option [value]="block._id" *ngFor="let block of block_hover">{{block.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Nội dung chữ -->
      <div class="field-row">
        <div class="config-font" *ngIf="!objectChoosing.dynamic_data" style="width:100%">
          <mat-form-field style="width:100%">
            <mat-label>{{'noi_dung_chu' | translate}}</mat-label>
            <textarea style="height:80px;background: #edf6fd;
            padding:10px 6px;font-size:13px;border-top-left-radius:5px;
            border-top-right-radius:5px" matInput 
              [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component" 
              (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"  
              (blur)="updateContent()"></textarea>
          </mat-form-field>
        </div>
      </div>

      <!-- Biểu tượng -->
      <app-symbol-config [device]="device" [class]="class" [config]="config" [symbolClass]="class['text__wrapper']"
      [fontSizeIconClass]="class['text__wrapper--icon']" [symbolConfig]="config['flex-direction']"
      [objectChoosing]="objectChoosing">
      </app-symbol-config>
    </div>
  </ng-container>

 
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">

     <!-- Chọn khối hiển thị -->
    <mat-form-field  style="margin-top: 10px">
      <mat-label>{{'chon_khoi_hien_thi' | translate}}</mat-label>
      <mat-select [(ngModel)]="staticdata['id_freeblock']" (ngModelChange)="updateObject()">
        <mat-option [value]="block._id" *ngFor="let block of block_hover">{{block.name}}</mat-option>
      </mat-select>
    </mat-form-field>

    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <!-- Lựa chọn hiển thị cho các thiết bị -->
        <div class="editor-field">
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li> 
      <!-- CHỮ VÀ ĐỊNH DẠNG-->
      <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <div class="editor-field">
          <div class="editor-field-body">
            <!-- Hiển thị số dòng -->
            <div class="field-row">
              <div class="config-name mt-2" style="gap:10px">
                <p class="m-0" style="line-height:1.5">{{'hien_thi_so_dong' | translate}}</p>
                <nz-input-number [nzMin]="1" [nzMax]="10" [nzStep]="1" [ngStyle]="{ width: '40%' }"
                  [(ngModel)]="class['text__content']['-webkit-line-clamp']" (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
            </div>
            <!-- Nội dung chữ -->
            <div class="field-row">
              <div class="config-font" *ngIf="!objectChoosing.dynamic_data" style="width:100%">
                <mat-form-field style="width:100%">
                  <mat-label>{{'noi_dung_chu' | translate}}</mat-label>
                  <textarea style="height:80px;background: #edf6fd;
                  padding:10px 6px;font-size:13px;border-top-left-radius:5px;
                  border-top-right-radius:5px" matInput 
                    [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component" 
                    (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"  
                    (blur)="updateContent()"></textarea>
                </mat-form-field>
              </div>
            </div>
            <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
              [config]="config" [staticdata]="staticdata" [textContentClass]="class['text__content']"
              [textWrapperClass]="class['text__wrapper']">
            </app-text-format-config>
            <div class="config-name">
              <p>{{'xuong_dong' | translate}}</p>
              <nz-switch [ngModel]="class['text__content']['white-space'] && class['text__content']['white-space'] !== 'nowrap'"
              (ngModelChange)="class['text__content']['white-space'] = $event ? 'pre-wrap' : 'nowrap';updateClass()"></nz-switch>
            </div>
            <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
            <div class="field-row">
              <!-- Gradient -->
              <div class="config-font">
                <div style="display: flex; align-items: center; justify-content: space-between;">
                  <p class="m-0" style="line-height:1.5">{{'do_mau_gradient' | translate}} <span style="font-size:13px">({{'da_sac' | translate}})</span>
                  </p>
                  <nz-switch [(ngModel)]="config['background-image'].gradient_check"
                    (ngModelChange)="handleSetGradientText()">
                  </nz-switch>
                </div>
                <div class="container-gradient" *ngIf="config['background-image'].gradient_check">
                  <div class="list-gradient">
                    <button class="btn-gradient"
                      *ngFor="let bgGradient of config['background-image']['background_image_arr_gradient']; let i = index"
                      (click)="deleteGradient(i)" [ngStyle]="{'backgroundColor': bgGradient}"
                      [disabled]="!config['background-image'].gradient_check">
                      <i class="delete-icon bi bi-x-circle"></i>
                    </button>
                  </div>
                  <p class="title-head">{{ 'them_mau' | translate }}</p>
                  <div class="container_add-gradient">
                    <button class="btn-add-gradient" nzTooltipTitle="{{ 'them_mau' | translate }}" nz-tooltip
                      [disabled]="!config['background-image'].gradient_check" (click)="openbgGradient()"
                      (blur)="addGradient()">
                      <input nz-input type="color" class="picking-gradient" id="input-gradient"
                        [(ngModel)]="config['background-image']['background_image_background_color']">
                      <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                    </button>
                    <div class="slide_container-gradient">
                      <input type="range" min="1" max="100"
                        [value]="config['background-image']['background_image_opacity']" class="slider-gradient"
                        (input)="getValueRangeBackgroundGradient($event)"
                        [disabled]="!config['background-image'].gradient_check"
                        [ngStyle]="{background: 'linear-gradient(to right, transparent,#2764EB,#EFE810), url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)'}">
                    </div>
                    <div class="value-range">{{config['background-image']['background_image_opacity']}}%</div>
                  </div>
                  <p class="title-head">{{ 'huong_phoi_mau' | translate }}</p>
                  <button class="gradient-direction" *ngFor="let type of typeGradient" nz-tooltip
                    [nzTooltipTitle]="type.name" (click)="chooseOption(type, $event)"
                    [disabled]="!config['background-image'].gradient_check"
                    [style.background]="'linear-gradient('+ type.deg +', #2764EB, #EFE810)'"
                    [ngClass]="{ 'active': config['background-image']['background_image_direction'] === type.direction}">
                  </button>
                </div>
              </div>
            </div>
            <!-- Canh lề -->
            <div class="field-row">
              <div class="config-font" style="margin-top:20px">
                <!-- Khoảng cách chữ -->
                <div>
                  <div class="config-name" style="gap:5px">
                    <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_chu' | translate }}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngStyle]="{ width: '40%' }"
                      [ngModel]="class['text__content']['letter-spacing'] | vhnumber" (nzBlur)="updateClass()"
                      (ngModelChange)="class['text__content']['letter-spacing'] = $event +'px'">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="50"
                        [ngModel]="class['text__content']['letter-spacing'] | vhnumber"
                        (nzOnAfterChange)="updateClass();"
                        (ngModelChange)="class['text__content']['letter-spacing'] = $event +'px'">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Khoảng cách dòng -->
                <div>
                  <div class="config-name">
                    <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_dong' | translate }}</p>
                    <nz-input-number [ngStyle]="{ width: '40%' }"
                      [(ngModel)]="this.class['text__content']['line-height']" (nzBlur)="updateClass()" [nzMin]="0.5"
                      [nzMax]="3" [nzStep]="0.1">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                        [(ngModel)]="this.class['text__content']['line-height']" (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- Biểu tượng  -->
      <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu7"
        (nzOpenChange)="openHandler('menu7')">
        <app-symbol-config [device]="device" [class]="class" [config]="config" [symbolClass]="class['text__wrapper']"
          [fontSizeIconClass]="class['text__wrapper--icon']" [symbolConfig]="config['flex-direction']"
          [objectChoosing]="objectChoosing">
        </app-symbol-config>
      </li>
      <!-- PHONG CÁCH -->
      <li nz-submenu nzTitle="{{'phong_cach_va_kieu_co' | translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <app-text-style-config [device]="device" [config]="config" [class]="class"
          [textContentClass]="class['text__content']" [textWrapperClass]="class['text__wrapper']"
          [filterConfig]="config['filter']" [isShape]="false" [objectChoosing]="objectChoosing">

        </app-text-style-config>
      </li>
      <!-- Cấu hình xoay-->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu8"
        (nzOpenChange)="openHandler('menu8')">
        <app-rotate-config [classRotate]="class['text']" [config]="config" [device]="device"
          [objectChoosing]="objectChoosing"></app-rotate-config>
      </li>
      <!-- Cấu hình khoảng đệm-->
      <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMap.menu11"
        (nzOpenChange)="openHandler('menu11')">
        <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
          [classPadding]="class['text__content']" [paddingConfigs]="[
          { type: 'top' },
          { type: 'bottom' },
          { type: 'left' },
          { type: 'right' },
        ]">
        </app-padding-config>
      </li>
      <!-- Cấu hình viền-->
      <li nz-submenu nzTitle="{{'vien' | translate}}" [(nzOpen)]="openMap.menu12"
        (nzOpenChange)="openHandler('menu12')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderClass]="class['text__content']" [id_object]="objectChoosing._id">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
            {{'bo_goc' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- HIỆU ỨNG -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <app-choose-animations-config
          [elementChoosing]="objectChoosing"
          [id_object]="objectChoosing._id"
          [device]="device"
          [class]="class"
          [config]="config"
          [staticdata]="staticdata"
          [cursorClass]="class['text']"
          [effect_hover]="effect_hover"
          [customize]="customize"
          (openAnimationDetail)="openAnimationDetail($event)"
          [effectFileUsing]="'text'">
        </app-choose-animations-config>
      </li>
      <!-- VỊ TRÍ KHỐI HỘP THOẠI -->
      <li nz-submenu nzTitle="{{'vi_tri_khoi_hop_thoai' |translate}}"
        [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <div class="field-row">
          <div class="config-font">
            <p class="title" style="margin-top:14px">Vị trí</p>
            <div class="font">
              <button class="font-text-btn" nz-button [nzType]="
                  class['text__hover']['left'] == '0px'
                    ? 'primary'
                    : 'default'" (click)="handleSetBlockPosition('left');">
                <i nz-icon nzType="align-left" nzTheme="outline"></i>
              </button>
              <button class="font-text-btn" nz-button [nzType]="
                  class['text__hover']['transform'] != 'none'
                    ? 'primary'
                    : 'default'" (click)="handleSetBlockPosition('center');">
                <i nz-icon nzType="align-center" nzTheme="outline"></i>
              </button>
              <button class="font-text-btn" nz-button [nzType]="
                  class['text__hover']['right'] == '0px'
                    ? 'primary'
                    : 'default'" (click)="handleSetBlockPosition('right');">
                <i nz-icon nzType="align-right" nzTheme="outline"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- Khoảng cách với chữ -->
        <div class="field-row">
          <div style="display: flex; align-items: center; justify-content: space-between;" class="mb-2">
            <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_duoi' | translate }}</p>
            <nz-switch [ngModel]="config.is_distance_bottom"
              (ngModelChange)="toggleTopOrBottom($event)">
            </nz-switch>
          </div>
          <div class="font-text-linespacing">
            <div class="config-name" style="gap:5px">
              <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_chu' | translate }}</p>
              <nz-input-number [nzMin]="0" [nzMax]="500" [ngStyle]="{ width: '40%' }"
                [ngModel]="class['text__hover'][config.is_distance_bottom ? 'bottom' : 'top'] | vhnumber" (nzBlur)="updateClass()"
                (ngModelChange)="class['text__hover'][config.is_distance_bottom ? 'bottom' : 'top'] = $event + 'px'">
              </nz-input-number>
            </div>
            <nz-row>
              <nz-col nzSpan="24">
                <nz-slider [nzMin]="0" [nzMax]="500" (nzOnAfterChange)="updateClass();"
                  [ngModel]="class['text__hover'][config.is_distance_bottom ? 'bottom' : 'top'] | vhnumber"
                  (ngModelChange)="class['text__hover'][config.is_distance_bottom ? 'bottom' : 'top'] = $event + 'px'">
                </nz-slider>
              </nz-col>
            </nz-row>
          </div>
        </div>
      </li>
      <!-- THÊM LIÊN KẾT -->
      <li nz-submenu nzTitle="{{'lien_ket' | translate}}" [(nzOpen)]="openMap.menu6"
        (nzOpenChange)="openHandler('menu6')">

        <app-link-page-config [objectChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id"></app-link-page-config>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="this.config['animation-selected'].id != '000000'">
       <app-animations-config [elementChoosing]="objectChoosing" [type]="type" [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [customize]="customize"></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['text__content']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>